/* ============================================================
   STAFF ACCENTS
   The colour belongs to the staff member, not the booking: a
   column takes one of the six brand accents and every card
   inside it wears the same one, so a glance down the day says
   whose column you are reading.

   The index is the staff member's rank in an id-sorted roster
   rather than their position in the day's filtered list — the
   API can hand the roster back in any order, and a colleague
   being off on Tuesday must not repaint everyone else's column.
   ============================================================ */

export const ACCENT_COUNT = 6;

/* staffId → accent index. Distinct while the shop has six staff or fewer,
   and stable for the whole week no matter who is working which day. */
export const buildStaffAccents = (staff = []) => {
	const accents = {};

	[...staff]
		.map((s) => s?.staffId)
		.filter(Boolean)
		.sort()
		.forEach((staffId, rank) => {
			accents[staffId] = rank % ACCENT_COUNT;
		});

	return accents;
};
